/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { destinationsEnable } from "../../funcs/destinationsEnable.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
  destinationId: z.string(),
};

export const tool$destinationsEnable: ToolDefinition<typeof args> = {
  name: "destinations-enable",
  description: `Enable Destination

Enables a previously disabled destination.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await destinationsEnable(
      client,
      args.tenantId,
      args.destinationId,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
